import React from 'react';
import Link from 'next/link';

interface BlogLayoutProps {
  children: React.ReactNode;
  showBreadcrumb?: boolean;
  breadcrumbItems?: Array<{ label: string; href?: string }>;
}

export const BlogLayout: React.FC<BlogLayoutProps> = ({
  children,
  showBreadcrumb = true,
  breadcrumbItems = []
}) => {
  // The blog lives at /blog on a single origin now, so this is a constant
  // rather than a host-dependent value resolved after hydration.
  const blogHref = '/blog';

  return (
    <main className="flex-1">
      {showBreadcrumb && (
        <div className="bg-[#080C18] border-b border-gray-700">
          <div className="container mx-auto px-4 py-4">
            <nav className="flex items-center space-x-2 text-sm">
              <Link
                href="/"
                className="text-gray-400 hover:text-white transition-colors"
              >
                Home
              </Link>
              <span className="text-gray-500">/</span>
              <Link
                href={blogHref}
                className="text-gray-400 hover:text-white transition-colors"
              >
                Blog
              </Link>
              {breadcrumbItems.map((item, index) => (
                <React.Fragment key={index}>
                  <span className="text-gray-500">/</span>
                  {item.href ? (
                    <Link 
                      href={item.href} 
                      className="text-gray-400 hover:text-white transition-colors"
                    >
                      {item.label}
                    </Link>
                  ) : (
                    <span className="text-white">{item.label}</span>
                  )}
                </React.Fragment>
              ))}
            </nav>
          </div>
        </div>
      )}
      
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          {children}
        </div>
      </div>
    </main>
  );
};
